'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' });

var ContentCopy = function ContentCopy(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ContentCopy = (0, _pure2.default)(ContentCopy);
ContentCopy.muiName = 'SvgIcon';

exports.default = ContentCopy;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ContentCopy.js
// module id = 2277
// module chunks = 0